import { ReactNode } from 'react'

interface PremiumHeaderProps {
  title: string
  subtitle?: string
  eyebrow?: string
  primaryAction?: ReactNode
  secondaryAction?: ReactNode
  children?: ReactNode
}

export default function PremiumHeader({
  title,
  subtitle,
  eyebrow,
  primaryAction,
  secondaryAction,
  children,
}: PremiumHeaderProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <div className="min-w-0 flex-1">
        {eyebrow && (
          <div className="mb-1 inline-flex items-center rounded-full bg-blue-100 px-3 py-0.5 text-xs font-medium text-blue-800 uppercase tracking-wide">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {(primaryAction || secondaryAction || children) && (
        <div className="flex flex-wrap gap-2">
          {secondaryAction}
          {primaryAction}
          {children}
        </div>
      )}
    </div>
  )
}
